"use client";

import { useViewportHeight, type ViewportHeight } from "@/hooks/useViewPortHeight";
import React, { createContext, type ReactNode, useContext } from "react";

interface ViewportHeightContextValue extends ViewportHeight {
}

const ViewportHeightContext = createContext<ViewportHeightContextValue | undefined>(
    undefined,
);

interface ViewportHeightProviderProps {
    children: ReactNode;
    /** 防抖延迟时间（单位：ms），默认 100 */
    debounceDelay?: number;
}

export const ViewportHeightProvider: React.FC<ViewportHeightProviderProps> = ( {
    children,
    debounceDelay,
} ) => {
    const viewportHeight = useViewportHeight( {
        debounceDelay,
    } );

    // ! 关于经典菜单导航，需要原生支持, 正常的gesture bar 可以通过css获取
    return (
        <ViewportHeightContext.Provider value={viewportHeight}>
            {children}
        </ViewportHeightContext.Provider>
    );
};

/**
 * 获取全局视口高度信息
 * @throws 如果在 ViewportHeightProvider 外部使用会抛出错误
 * @example
 * ```tsx
 * function MyComponent() {
 *   const { height, isKeyboardOpen } = useViewportHeightContext();
 *   return <div style={{ height: `${height}px` }}>...</div>;
 * }
 * ```
 */
export const useViewportHeightContext = (): ViewportHeightContextValue => {
    const context = useContext( ViewportHeightContext );

    if ( context === undefined ) {
        throw new Error(
            "useViewportHeightContext need used in  ViewportHeightProvider",
        );
    }

    return context;
};
